// İş İstasyonu Ekle / Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.workCenterForm';

export const productionWorkCenterFormGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'İş istasyonu nasıl eklenir?'),
  intro: t(`${G}.intro`, 'İş istasyonu, üretim adımlarının yapıldığı makine ya da bölümdür. Burada girdiğiniz saatlik maliyetler üretim fişinin dönüşüm (makine + işçilik) maliyetini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İş istasyonu'),
    body: t(`${G}.regions.body`, 'Kod, ad, maliyet, kapasite'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kod, ad ve şube'),
      text: t(`${G}.s1.text`, '"Kod" (1–30 karakter) ve "Ad" (1–200 karakter) zorunludur; aynı kod ikinci kez kullanılamaz. "Şube" boşsa istasyon şirket genelidir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube yöneticisi yalnız kendi şubesine istasyon ekler; şube alanı kilitli gelir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Saatlik maliyetler'),
      text: t(`${G}.s2.text`, '"Makine ₺/saat" ve "İşçilik ₺/saat" 0 ile 1.000.000 arasında olmalıdır. Adımda geçen süre (dk) / 60 ile çarpılarak adımın makine ve işçilik maliyeti bulunur ve tamamlanan fişin fiili maliyetine eklenir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Saatlik maliyet, operasyonlu fiş oluşturulurken fişin adımlarına kopyalanır. Sonradan yaptığınız değişiklik yeni açılan fişlerde geçerli olur.'),
        t(`${G}.s2.tip2`, '"Para birimi" TRY değilse tutar çevrilmeden kullanılır ve fişte "İstasyon maliyetinin para birimi TRY değil; çevrilmeden kullanıldı." uyarısı çıkar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kapasite ve açıklama'),
      text: t(`${G}.s3.text`, '"Günlük kapasite (saat)" 0–24 arasındadır ve boş bırakılabilir; "Paralel birim" 1–999 arasındadır. İkisi listede "Kapasite" olarak gösterilir, bilgi amaçlıdır; süre ve maliyet hesabına girmez. "Açıklama" isteğe bağlıdır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Durum ve Kaydet'),
      text: t(`${G}.s4.text`, 'Anahtar istasyonun Aktif / Pasif durumunu belirler; atölye ekranındaki istasyon listesinde yalnız aktif istasyonlar çıkar. "Kaydet"e basın; hata varsa pencerenin üstünde kırmızı mesaj çıkar.'),
    },
  ],
});
